<script lang="ts" setup>
defineProps({
    isSolid: {
        type: Boolean,
        default: false
    }
})
</script>

<template>
    <svg
        v-if="isSolid"
        xmlns="http://www.w3.org/2000/svg"
        class="fill-current"
        viewBox="0 0 24 24"
    >
        <path
            fill-rule="evenodd"
            d="M14.6152 1.59495c.3013.16794.4491.51968.3584.85241L12.982 9.75003h7.268c.2987 0 .5689.17718.6879.45107.119.2739.0642.5923-.1396.8107l-10.5 11.25c-.2353.2521-.61226.3112-.91349.1433-.30124-.1679-.44911-.5197-.35837-.8524L11.0181 14.25H3.75002c-.29865 0-.56884-.1772-.68786-.4511-.11903-.2739-.06421-.5923.13957-.8106L13.7017 1.73829c.2353-.25214.6123-.31128.9135-.14334Z"
            clip-rule="evenodd"
        />
    </svg>

    <svg
        v-else
        xmlns="http://www.w3.org/2000/svg"
        class="fill-current"
        viewBox="0 0 24 24"
    >
        <path
            fill-rule="evenodd"
            d="M14.737 1.3766c.4016.22393.5988.6929.4778 1.13655l-1.9055 6.98688H20.25c.3982 0 .7585.23625.9172.60147.1587.3652.0856.7897-.1861 1.0809l-10.5 11.25c-.3138.3361-.81638.415-1.21802.1911-.40165-.224-.59882-.6929-.47782-1.1366L10.6908 14.5H3.75002c-.3982 0-.75844-.2362-.91715-.6014-.1587-.3652-.0856-.7898.1861-1.0809L13.519 1.56772c.3137-.33618.8163-.41504 1.218-.19112ZM6.05124 12.5H12c.3117 0 .6055.1454.7947.393.1892.2477.2521.5695.1701.8702l-1.1856 4.3471L17.9488 11.5H12c-.3117 0-.6055-.1453-.7947-.393-.1892-.2477-.252-.5694-.17-.8701l1.1856-4.34716L6.05124 12.5Z"
            clip-rule="evenodd"
        />
    </svg>
</template>
